import React, { FC, useCallback, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

import { columns, IData } from './OTCBalanceTableLists'
import { TableSmall } from '../../../../../../components/Dashboard/TableSmall'
// import { GreenButton } from '../../../../../../components/Dashboard/Buttons/GreenButton'
import { MemoTransferPopup } from '../TransferPopup'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  title: {
    justifyContent: 'space-between',
    minHeight: 40,
    maxHeight: 40,
  },
  section: {
    width: '100%',
    height: '100%',
    padding: theme.spacing(0, 4, 0, 4),
    background: theme.palette.background.paper,
    // textAlign: 'right',
  },
  subtitle: {
    paddingTop: theme.spacing(4),
  },
}))

interface INewData {
  fiatСurrencies: string
}

interface IOTCTradingBalances {
  title?: string
  // eslint-disable-next-line
  data: any
  currencyType: string
  loading: boolean
}

export const OTCTradingBalances: FC<IOTCTradingBalances> = ({ title, data, currencyType, loading }) => {
  const formMethods = useForm({
    mode: 'onBlur',
  })

  const classes = useStyles()

  // const [isOpenModal, setOpen] = useState<boolean>(false)
  const [isOpenModal] = useState<boolean>(false)
  const [newData, setNewData] = useState<INewData[]>([])

  const toggleModal = useCallback(() => {
    // setOpen((prevState) => !prevState)
    // }, [setOpen])
  }, [])

  const transformData = useCallback(() => {
    setNewData(
      currencyType === 'fiat'
        ? data.map((item: IData) => ({ fiatСurrencies: `${item.asset}: ${item.amount}` }))
        : data.map((item: IData) => ({ cryptoСurrencies: `${item.asset}: ${item.amount}` })),
    )
  }, [currencyType, data])

  useEffect(() => {
    if (data) transformData()
    // eslint-disable-next-line
  }, [data])

  return (
    <>
      <Grid item xs={12} className={classes.container}>
        <FormProvider {...formMethods}>
          <Grid container item xs={12} className={classes.title}>
            {title && (
              <>
                <Typography variant={'h6'}>{title}</Typography>
                {/* <GreenButton width={130} height={25} fontSize={12} text={'Transfer to Staking'} onClick={toggleModal} /> */}
              </>
            )}
          </Grid>

          <Grid item xs={12} className={classes.section}>
            <TableSmall
              columns={currencyType === 'fiat' ? columns.fiatColumns : columns.cryptoColumns}
              data={newData}
              loading={loading}
            />
          </Grid>
        </FormProvider>
      </Grid>

      <MemoTransferPopup isOpen={isOpenModal} modalClose={toggleModal} title={'Transfer to Staking'} />
    </>
  )
}
